import React, { useEffect, useState, useContext } from 'react';

import { Loader } from '../components/crm/shared/CommonItems';
import { HandleAddActivity, HandleRemoveActivity } from '../components/crm/requests/ActivityRequests';
import { HandleAddNote, HandleRemoveNote, HandleUpdateNote } from '../components/crm/requests/NoteRequests';
import { HandleAddFile, HandleRemoveFile } from '../components/crm/requests/FileRequests';
import { updateDealProps, updatePersonProps, updateOrganizationProps } from '../components/crm/shared/Functions';
import { GetDealHistory, GetActiveDeal } from '../components/crm/requests/DealRequests';
import { ActivityPanel } from '../components/crm/shared/DetailContent';
import { CompletedHistoryFetch } from '../components/crm/shared/Functions';
import { HistoryPanel } from '../components/crm/shared/HistoryItems';
import {
    ItemDetails,
    createDealFieldComponents,
    createOrganizationFieldComponents,
    createPersonFieldComponents,
} from '../components/crm/shared/ItemDetails';
import DealHeader from '../components/crm/deal/DealHeader';
import Toasts from '../components/crm/shared/Toasts';

import { DeepCopy } from '../components/tables/shared/TableEventHelpers';
import { scrollToHistoryAnchor } from '../components/crm/shared/field_inputs/shared/EventHelpers';

import { DataContext } from '../stores/crm-deal-store';
import { DataContext as SharedDataContext } from '../stores/crm-store';
import { DataContext as OrgDataContext } from '../stores/crm-organization-store';
import { DataContext as PersonDataContext } from '../stores/crm-person-store';

import ErrorPage from './error';
import { ITEM_TITLE_CONTACT_PERSON, ITEM_TITLE_DETAILS, ITEM_TITLE_ORGANIZATION, REMOVE_ACTIVITY_WARNING, REMOVE_FILE_WARNING, REMOVE_NOTE_WARNING, UNABLE_TO_CREATE_SUBCONTRACTOR, UNABLE_TO_CREATE_SUBCONTRACTOR_BEFORE_ADDING_ORG } from '../i18n/keyConstants';
import { useTranslation } from 'react-i18next';

const CrmDealDetails = ({ id }) => {
    const { t } = useTranslation(['itemDetails', 'removeContent']);
    const [error] = useState(null);
    const [, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingHistory, setIsLoadingHistory] = useState(false);
    const [activeContent, setActiveContent] = useState(0);
    const [activeHistoryContent, setActiveHistoryContent] = useState(0);
    const [historyCollection, setHistoryCollection] = useState({
        activities: [],
        notes: [],
        files: [],
        changelogs: [],
    });
    const {
        store: { activeDeal, pipelines, currentPipelineId },
        dispatch,
    } = useContext(DataContext);
    const { store: sharedStore, dispatch: sharedDispatch } = useContext(SharedDataContext);

    const {
        store: { rows: orgRows },
        dispatch: orgDispatch,
    } = useContext(OrgDataContext);

    const {
        store: { rows: personRows },
        dispatch: personDispatch,
    } = useContext(PersonDataContext);

    const currentPath = window.location.pathname;

    /*
     * ===================================================================================================
     *                                       FUNCTIONS
     * ===================================================================================================
     */

    const finishedHistoryFetch = (res) => {
        if (res.success) {
            res = CompletedHistoryFetch(res, sharedStore);

            // Update pipelineStage from pipelinestageId
            /*var dealActive = DeepCopy(activeDeal);
            dealActive.pipelineStage = pipelines[currentPipelineId].pipelineStages.find(
                (pipelineStage) => pipelineStage.id === pipeLineStageId
            );
            dispatch({
                type: 'UPDATE_ACTIVE_DEAL',
                payload: dealActive,
            }); */

            setHistoryCollection({
                activities: res.data.activities,
                notes: res.data.notes,
                files: res.data.files,
                changelogs: res.data.changelogs,
            });
        }

        setIsLoadingHistory(false);
    };

    async function finishedDealFetch(res) {
        if (res.success) {
            dispatch({
                type: 'UPDATE_ACTIVE_DEAL',
                payload: res.data,
            });
            dispatch({
                type: 'UPDATE_CURRENT_PIPE_STAGE_ID',
                pipelineStageId: res.data.pipelineStageId,
            });
            dispatch({
                type: 'UPDATE_CURRENT_PIPE_ID',
                pipelineId: res.data.pipelineStage.pipelineId,
            });
        }
        setIsLoading(false);
    }

    async function PostActivity(activity) {
        let newDeal = DeepCopy(activeDeal);

        activity['dealId'] = activeDeal.id;
        activity['organizationId'] = activeDeal.customerId;
        activity['ownerId'] = activeDeal.ownerId;

        activity['activityPersons'] = [];
        for (let i = 0; i < activity.persons.length; i++) {
            activity['activityPersons'][i] = {
                type: 1,
                personId: activity.persons[i].id,
            };
        }

        setIsSaving(true);
        let response = await HandleAddActivity(activity, setIsSaving);

        if (response.success) {
            let activity = response.data;
            activity.organization = activeDeal.customer;

            newDeal.activities.push(activity);
            //newDeals[id] = newDeal;

            dispatch({ type: 'UPDATE_ACTIVE_DEAL', payload: newDeal });
            dispatch({ type: 'SHOW_SAVED_TOAST' });
        } else {
            sharedDispatch({ type: 'SHOW_ERROR_TOAST' });
        }
    }

    async function PostNote(note) {
        let newDeal = DeepCopy(activeDeal);

        note['dealId'] = activeDeal.id;

        setIsSaving(true);
        let response = await HandleAddNote(note);
        setIsSaving(false);

        if (response.success) {
            let note = response.data;

            newDeal.notes.push(note);

            dispatch({ type: 'UPDATE_ACTIVE_DEAL', payload: newDeal });
            sharedDispatch({ type: 'SHOW_SAVED_TOAST' });
        } else {
            sharedDispatch({ type: 'SHOW_ERROR_TOAST' });
        }
    }

    async function RemoveNote(note) {
        var confirm = window.confirm(t(REMOVE_NOTE_WARNING));

        if (confirm) {
            let newDeal = DeepCopy(activeDeal);

            setIsSaving(true);
            let response = await HandleRemoveNote(note);
            setIsSaving(false);

            if (response.success) {
                let note = response.data;

                newDeal.notes.splice(newDeal.notes.indexOf(note), 1);

                dispatch({ type: 'UPDATE_ACTIVE_DEAL', payload: newDeal });
                sharedDispatch({ type: 'SHOW_SAVED_TOAST' });
            } else {
                sharedDispatch({ type: 'SHOW_ERROR_TOAST' });
            }
        }
    }

    async function UpdateNote(newText, note) {
        let newNote = DeepCopy(note);
        newNote.text = newText;

        setIsSaving(true);
        let response = await HandleUpdateNote(newNote);
        setIsSaving(false);
        if (response.success) {
            sharedDispatch({ type: 'SHOW_SAVED_TOAST' });
        } else {
            sharedDispatch({ type: 'SHOW_ERROR_TOAST' });
        }

        return response;
    }

    async function PostFile(file) {
        let newDeal = DeepCopy(activeDeal);

        file['dealId'] = activeDeal.id;
        file['ownerId'] = activeDeal.ownerId;
        file['orgId'] = activeDeal.customer.id;

        setIsSaving(true);
        let response = await HandleAddFile(file);
        setIsSaving(false);

        if (response.success) {
            let file = response.data;

            newDeal.files.push(file);

            dispatch({ type: 'UPDATE_ACTIVE_DEAL', payload: newDeal });
            sharedDispatch({ type: 'SHOW_SAVED_TOAST' });
        } else {
            sharedDispatch({ type: 'SHOW_ERROR_TOAST' });
        }
    }

    async function DownloadFile(file) {
        let url = `api/crmFileFront/${file.id}/download`;

        var link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.download = file.name;
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    async function RemoveFile(file) {
        var confirm = window.confirm(t(REMOVE_FILE_WARNING));

        if (confirm) {
            let newDeal = DeepCopy(activeDeal);

            setIsSaving(true);
            let response = await HandleRemoveFile(file);
            setIsSaving(false);

            if (response.success) {
                let file = response.data;

                newDeal.files.splice(newDeal.files.indexOf(file), 1);

                dispatch({ type: 'UPDATE_ACTIVE_DEAL', payload: newDeal });
                sharedDispatch({ type: 'SHOW_DELETED_TOAST' });
            } else {
                sharedDispatch({ type: 'SHOW_ERROR_TOAST' });
            }
        }
    }

    async function RemoveActivity(activity) {
        var confirm = window.confirm(t(REMOVE_ACTIVITY_WARNING));

        if (confirm) {
            let newDeal = DeepCopy(activeDeal);

            setIsSaving(true);
            let response = await HandleRemoveActivity(activity, setIsSaving);

            if (response.success) {
                let activity = response.data;

                newDeal.activities.splice(newDeal.activities.indexOf(activity), 1);

                dispatch({ type: 'UPDATE_ACTIVE_DEAL', payload: newDeal });
                sharedDispatch({ type: 'SHOW_SAVED_TOAST' });
            } else {
                sharedDispatch({ type: 'SHOW_ERROR_TOAST' });
            }
        }
    }

    const checkNewUnderConsultatCreated = (newProps) => {
        if (newProps.underConsultants != null && newProps.underConsultants.length > 0) {
            //check if there only is one underCo. company
            if (activeDeal.underConsultantOrganizations.length === 1) {
                return null;
            }
            if (activeDeal.underConsultantOrganizations.length === 0) {
                alert(t(UNABLE_TO_CREATE_SUBCONTRACTOR_BEFORE_ADDING_ORG));
                return { success: false, payload: null };
            }

            let newUnderConsultant = false;

            newProps.underConsultants.forEach((v) => {
                if (v.id == null) {
                    alert(t(UNABLE_TO_CREATE_SUBCONTRACTOR));
                    newUnderConsultant = true;
                    return;
                }
            });

            if (newUnderConsultant) return { sucess: false, payload: null };
            else return null;
        }

        return null;
    };

    const updateStore = (newDeal) => {
        if (typeof pipelines[currentPipelineId] !== undefined && pipelines[currentPipelineId]?.pipelineStages !== undefined) {
            const pipelineStageDeals = pipelines[currentPipelineId].pipelineStages.find(
                (pipelineStage) => pipelineStage.id === newDeal.pipelineStageId
            );

            const dealInPipelineStage = pipelineStageDeals.deals;
            const indexToUpdate = dealInPipelineStage.findIndex((p) => p.id === newDeal.id);
            dealInPipelineStage[indexToUpdate] = newDeal;

            if (indexToUpdate >= 0) {
                dispatch({
                    type: 'UPDATE_FETCH_PIPES',
                    pipelines: pipelines,
                });
            }
        }
    };

    const updateCustomersInStore = (newDeal) => {
        if (typeof pipelines[currentPipelineId] !== undefined && pipelines[currentPipelineId]?.pipelineStages !== undefined) {
            const dealInPipelineStage = pipelines[currentPipelineId].pipelineStages.find(
                (pipelineStage) => pipelineStage.id === newDeal.pipelineStageId
            );
            const dealsInPipelineStage = dealInPipelineStage.deals;
            const indexToUpdate = dealsInPipelineStage.findIndex((p) => p.id === newDeal.id);
            dealsInPipelineStage[indexToUpdate] = newDeal;

            if (indexToUpdate >= 0) {
                for (var i = 0; i < pipelines[currentPipelineId].pipelineStages.length; i++) {
                    const deal = pipelines[currentPipelineId].pipelineStages[i].deals;

                    for (var j = 0; j < deal.length; j++) {
                        if (deal[j].customer.id == newDeal.customer.id) {
                            deal[j].customer = newDeal.customer;
                        }
                    }
                }

                for (var o = 0; o < orgRows.length; o++) {
                    if (orgRows[o].id == newDeal.customer.id) {
                        orgRows[o] = newDeal.customer;
                    }
                }

                for (var p = 0; p < personRows.length; p++) {
                    if (personRows[p].organization.id == newDeal.customer.id) {
                        personRows[p].organization = newDeal.customer;
                    }
                }

                dispatch({
                    type: 'UPDATE_FETCH_PIPES',
                    pipelines: pipelines,
                });
                orgDispatch({ type: 'UPDATE_DATA', payload: orgRows });
                personDispatch({ type: 'UPDATE_DATA', payload: personRows });
            }
        }
    };

    const updateDeal = async (newProps) => {
        let newUcError = checkNewUnderConsultatCreated(newProps);

        if (newUcError != null) {
            return newUcError;
        }

        const response = await updateDealProps(activeDeal, newProps);
        if (response.success) {
            updateStore(response.deal);
            dispatch({
                type: 'UPDATE_ACTIVE_DEAL',
                payload: response.deal,
            });
        }
        return response;
    };

    const updateCustomer = async (newProps) => {
        const response = await updateOrganizationProps(activeDeal.customer, newProps);
        if (response.success) {
            const newDeal = { ...activeDeal };
            newDeal.customer = response.organization;
            updateCustomersInStore(newDeal);
            dispatch({
                type: 'UPDATE_ACTIVE_DEAL',
                payload: newDeal,
            });
        }
        return response;
    };

    const updateContactPerson = async (newProps) => {
        const response = await updatePersonProps(activeDeal.contact, newProps);
        if (response.success) {
            const newDeal = { ...activeDeal };
            newDeal.contact = response.person;
            updateStore(newDeal);
            dispatch({
                type: 'UPDATE_ACTIVE_DEAL',
                payload: newDeal,
            });
        }
        return response;
    };

    /*
     * ===================================================================================================
     *                                       EFFECTS
     * ===================================================================================================
     */

    useEffect(() => {
        if (activeDeal === null || activeDeal.id !== id) {
            setIsLoading(true);
            GetActiveDeal(id, finishedDealFetch);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        async function getDealHistory() {
            if (activeDeal !== null && activeDeal.id === id) {
                setIsLoadingHistory(true);
                await GetDealHistory(id, finishedHistoryFetch);
            }
        }
        getDealHistory();
    }, [activeDeal]);

    useEffect(() => {
        if (activeDeal === null || activeDeal.id !== id) {
            setIsLoading(true);
            GetActiveDeal(id, finishedDealFetch);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPath]);

    useEffect(() => {
        const anchor = sharedStore.anchorTag;
        if (!isLoadingHistory && anchor) {
            scrollToHistoryAnchor(anchor, sharedDispatch);
        }
    }, [isLoadingHistory, sharedStore.anchorTag]);

    /*
     * ===================================================================================================
     *                                       COMPONENT
     * ===================================================================================================
     */

    if (error) {
        return <ErrorPage error={error} />;
    } else if (isLoading) {
        return (
            <section>
                <Loader />
            </section>
        );
    } else if (activeDeal === null) {
        return null;
    }

    return (
        <>
            <section>
                <div className='d-flex flex-column h-100 crm-container-details'>
                    <DealHeader {...{ activeDeal, updateDealProps }} />
                    <div className='d-flex flex-row'>
                        <div className='d-flex flex-column detail-card-info'>

                            <ItemDetails
                                title={t(ITEM_TITLE_DETAILS)}
                                components={createDealFieldComponents(activeDeal, sharedStore, updateDeal, t)}
                                type={t(ITEM_TITLE_DETAILS)}
                            />
                            {activeDeal.customer && (
                                <ItemDetails
                                    title={t(ITEM_TITLE_ORGANIZATION)}
                                    components={createOrganizationFieldComponents(activeDeal.customer, sharedStore, updateCustomer, t)}
                                    type={t(ITEM_TITLE_ORGANIZATION)}
                                />
                            )}
                            {activeDeal.contact && (
                                <ItemDetails
                                    title={t(ITEM_TITLE_CONTACT_PERSON)}
                                    components={createPersonFieldComponents(activeDeal.contact, sharedStore, updateContactPerson, t)}
                                    type={t(ITEM_TITLE_CONTACT_PERSON)}
                                />
                            )}
                        </div>
                        <div className='d-flex flex-column detail-card-content'>
                            <ActivityPanel
                                activeContent={activeContent}
                                activeItem={activeDeal}
                                setActiveContent={setActiveContent}
                                PostActivity={PostActivity}
                                PostNote={PostNote}
                                PostFile={PostFile}
                                isDealChoiceShowing={false}
                            />
                            {isLoadingHistory ? (
                                <Loader />
                            ) : (
                                <HistoryPanel
                                    historyCollection={historyCollection}
                                    activeItem={activeDeal}
                                    activeHistoryContent={activeHistoryContent}
                                    setActiveHistoryContent={setActiveHistoryContent}
                                    removeNote={RemoveNote}
                                    updateNote={UpdateNote}
                                    removeActivity={RemoveActivity}
                                    removeFile={RemoveFile}
                                    downloadFile={DownloadFile}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </section>
            <Toasts />
        </>
    );
};

export default CrmDealDetails;
